import type { ReferrerStatus } from "@redotech/admin-sdk/rpc/schema/referrers/shared";
import type { RedoBadgeColor } from "@redotech/arbiter/badge/redo-badge";

/**
 * Visual config per referrer status. Mirrors V2_STATUS_BADGE_PROPS from
 * onboardings/v2/constants.ts so the admin app feels consistent across
 * features.
 *
 * The exhaustive `Record` ensures every ReferrerStatus has a config — adding
 * a new status to the enum will fail the build here until this table is
 * updated.
 */
export const REFERRER_STATUS_BADGE_PROPS: Record<
  ReferrerStatus,
  { color: RedoBadgeColor; text: string }
> = {
  active: { color: "success", text: "Active" },
  paused: { color: "warning", text: "Paused" },
  terminated: { color: "error", text: "Terminated" },
};
